import { combineReducers } from "redux";
import country from "../features/admin/masters/country/Slice";
import state from "../features/admin/masters/state/Slice";
import city from "../features/admin/masters/city/Slice";
import pincode from "../features/admin/masters/pincode/Slice";
import privacyandpolicy from "../features/admin/masters/privacyandpolicy/Slice";
import termsandconditions from "../features/admin/masters/termsandconditions/Slice";
import category from "../features/admin/masters/Category/Slice";
import sociallink from "../features/admin/masters/sociallink/Slice";
import ourteam from "../features/admin/masters/ourteam/Slice";
import appsetup from "../features/admin/masters/appsetup/Slice";
import faq from "../features/admin/masters/faq/Slice";
import studentDocument from "../features/admin/masters/studentDocument/Slice";

const masters = combineReducers({
  country: country,
  state: state,
  city: city,
  pincode: pincode,
  privacyandpolicy: privacyandpolicy,
  termsandconditions: termsandconditions,
  category: category,
  sociallink: sociallink,
  ourteam: ourteam,
  appsetup: appsetup,
  faq: faq,
  studentDocument: studentDocument,
});

export default masters;
